import * as React from 'react';
export const customersSvg = React.forwardRef(function customersSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.25A2.748 2.748 0 0 1 10.75.5a2.748 2.748 0 0 1 2.75 2.75A2.748 2.748 0 0 1 10.75 6 2.748 2.748 0 0 1 8 3.25ZM10.75 2c-.694 0-1.25.561-1.25 1.25 0 .694.561 1.25 1.25 1.25.694 0 1.25-.561 1.25-1.25S11.444 2 10.75 2ZM5 3.5a2.748 2.748 0 0 0-2.75 2.75A2.748 2.748 0 0 0 5 9a2.748 2.748 0 0 0 2.75-2.75A2.742 2.742 0 0 0 5 3.5ZM3.75 6.25C3.75 5.561 4.306 5 5 5c.697 0 1.25.553 1.25 1.25 0 .689-.556 1.25-1.25 1.25-.689 0-1.25-.556-1.25-1.25ZM3.776 10C1.686 10 0 11.703 0 13.795c0 .937.757 1.705 1.7 1.705h7.09c.933 0 1.71-.758 1.71-1.705C10.5 11.703 8.814 10 6.724 10H3.776ZM1.5 13.795A2.286 2.286 0 0 1 3.776 11.5h2.948A2.286 2.286 0 0 1 9 13.795a.211.211 0 0 1-.21.205H1.7a.203.203 0 0 1-.2-.205Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.25 7a.75.75 0 0 0 0 1.5h2.87c.483 0 1.094.227 1.585.662.48.425.795 1.002.795 1.668 0 .303.016.61-.008.912a8.52 8.52 0 0 1-.492.008h-2a.75.75 0 0 0 0 1.5h2.025c.468 0 .984.02 1.391-.251.502-.335.584-.943.584-1.499v-.67c0-1.173-.56-2.136-1.3-2.791C13.97 7.394 13.017 7 12.12 7H9.25Z',
    }),
  );
});
customersSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var customers = {
  category: 'icon',
  colorable: true,
  name: 'customers',
  svg: customersSvg,
};
